import React, { useEffect, useState } from 'react';

// eslint-disable-next-line no-unused-vars
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import { withMediaQueries } from 'hoc/withMediaQueries';

import MainFont from 'ui/typography/mainFont';
import { TOGGLE_SIDEBAR } from 'redux/slices/sidebar';

import { partnerRoles } from '../../../const';
import routes from '../../../routing/routes';
import { MODAL_OPEN } from 'redux/slices/modals';

import {
  Logo,
  MenuContainer,
  MenuIcon,
  MenuItem,
  MenuItemContainer,
  SupportIcon
} from './style';
import Support from '../Modals/Support';

const Menu = ({
  role,
  pushUrl,
  openSupportModal,
  toggleSidebar,
  isSidebarOpen
}) => {
  const [elements, setElements] = useState([]);
  const { t } = useTranslation();

  const location = useLocation();

  const menuRoles = {
    [partnerRoles.ADMIN]: [
      {
        name: 'lead',
        icon: 'icon-lead',
        to: routes.lead.path
      },
      // {
      //   name: t('order'),
      //   icon: 'icon-lightning',
      //   to: routes.home.path
      // },
      {
        name: 'people',
        icon: 'icon-pp-people',
        to: routes.people.path
      },
      {
        name: 'support',
        icon: 'icon-support',
        to: routes.home.path
      }
    ],
    [partnerRoles.COMMERCIAL_PARTNER_USER]: [
      {
        name: 'lead',
        icon: 'icon-lead',
        to: routes.lead.path
      },
      // {
      //   name: i18next.t('order'),
      //   icon: 'icon-lightning',
      //   to: routes.home.path
      // },
      {
        name: 'support',
        icon: 'icon-support',
        to: routes.home.path
      }
    ],
    [partnerRoles.COMMERCIAL_PARTNER_SUPER_USER]: [
      {
        name: 'lead',
        icon: 'icon-lead',
        to: routes.lead.path
      },
      // {
      //   name: 'orders',
      //   icon: 'icon-lightning',
      //   to: routes.home.path
      // },
      {
        name: 'people',
        icon: 'icon-pp-people',
        to: routes.people.path
      },
      {
        name: 'support',
        icon: 'icon-support',
        to: routes.home.path
      }
    ],
    [partnerRoles.TECHNICAL_PARTNER_USER]: [
      //{
      //  name: 'assignments',
      //  icon: 'icon-assignments',
      //  to: routes.home.path
      //},
      {
        name: 'support',
        icon: 'icon-support',
        to: routes.home.path
      }
    ],
    [partnerRoles.TECHNICAL_PARTNER_SUPER_USER]: [
      {
        name: 'people',
        icon: 'icon-pp-people',
        to: routes.people.path
      },
      //{
      //  name: 'assignments',
      //  icon: 'icon-assignments',
      //  to: routes.home.path
      //},
      {
        name: 'support',
        icon: 'icon-support',
        to: routes.home.path
      }
    ],
    // here only bc the role in my account is not updated
    SystemAdmin: [
      {
        name: 'lead',
        icon: 'icon-lightning',
        to: routes.lead.path
      },
      // {
      //   name: t('order'),
      //   icon: 'icon-lightning',
      //   to: routes.home.path
      // },
      {
        name: 'people',
        icon: 'icon-pp-people',
        to: routes.people.path
      },
      // {
      //   name: 'assignments',
      //   icon: 'icon-assignments',
      //   to: routes.home.path
      // },
      {
        name: 'support',
        icon: 'icon-support',
        to: routes.home.path
      }
    ]
  };

  useEffect(() => {
    if (role) {
      setElements([...(role ? menuRoles[role] : menuRoles.SystemAdmin)]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  const pushToHome = () => {
    pushUrl(routes.home.path);
  };

  const handleSupportModal = () => {
    openSupportModal();
  };

  if (elements) {
    return (
      <MenuContainer>
        <Logo onClick={pushToHome} />
        {location.pathname !== '/' && (
          <MenuItemContainer>
            {elements.map((el, id) => (
              <MenuItem
                key={id}
                className={
                  location.pathname.includes(el.to) && el.name !== 'support'
                    ? 'active'
                    : ''
                }
              >
                {el.name === 'support' ? (
                  <SupportIcon onClick={handleSupportModal} key={id}>
                    <MenuIcon className={el.icon} alt="icon" />
                    <MainFont type="4" configuration={{ fontSize: 10 }}>
                      {t(`${el.name}`).toUpperCase()}
                    </MainFont>
                  </SupportIcon>
                ) : (
                  <NavLink
                    to={el.to}
                    activeClassName="menuActive"
                    key={id}
                    onClick={() => {
                      if (isSidebarOpen) {
                        toggleSidebar();
                      }
                    }}
                  >
                    <MenuIcon className={el.icon} alt="icon" />
                    <MainFont type="4" configuration={{ fontSize: 10 }}>
                      {t(`${el.name}`).toUpperCase()}
                    </MainFont>
                  </NavLink>
                )}
              </MenuItem>
            ))}
          </MenuItemContainer>
        )}
        <Support />
      </MenuContainer>
    );
  }
  return <></>;
};

Menu.propTypes = {
  role: PropTypes.string,
  pushUrl: PropTypes.func
};

export default connect(
  state => ({
    role: state?.authentication?.accountInfo?.role,
    isSidebarOpen: state?.sidebar?.sidebarOpen
  }),
  dispatch => ({
    pushUrl: url => dispatch(push(url)),
    openSupportModal: payload =>
      dispatch(MODAL_OPEN({ id: 'support', payload })),
    toggleSidebar: () => dispatch(TOGGLE_SIDEBAR())
  })
)(withMediaQueries(Menu));
